import { GameConstants } from "../../../GameConstants";
import { StageContainer } from "../StageContainer";
import { GameVars } from "../../../GameVars";

export class Trunk extends Phaser.Sprite {

    private lane: number;

    constructor(game: Phaser.Game, x: number, y: number, lane: number) {

        super(game, x, y, "texture_atlas_1");

        this.lane = lane;   

        this.anchor.set(.5);
        
        const rnd = Math.random();

        if (rnd < .33) {
            this.animations.add("float", Phaser.Animation.generateFrameNames("trunk_1_", 1, 7, ".png", 4));
        } else if (rnd < .66) {
            this.animations.add("float", Phaser.Animation.generateFrameNames("trunk_2_", 1, 7, ".png", 4));
        } else {
            this.animations.add("float", Phaser.Animation.generateFrameNames("trunk_3_", 1, 7, ".png", 4));
        }

        this.play("float", 10, true);

        this.game.physics.enable(this, Phaser.Physics.ARCADE);

        const body = <Phaser.Physics.Arcade.Body> this.body;
        body.width = 45;
        body.height = 80;
        body.offset.y = -10;
        
        if (lane === 0) {
            this.name = GameConstants.RIVER_LANE_0;
        } else {
            this.name = GameConstants.RIVER_LANE_1;
        }
    }

    public update(): void {

        if (GameVars.paused) {
            return;
        }

        let speedFreeze = GameVars.freezeAction ? .15 : 1;

        if (this.lane === 0) {

            this.y += StageContainer.TRUNKS_VEL_0 * speedFreeze;
            
            if (this.y < StageContainer.TRUNKS_PY_0) {
                this.y = GameConstants.GAME_HEIGHT + 200;
            }

        } else {

            this.y += StageContainer.TRUNKS_VEL_1 * speedFreeze;

            if (this.y > StageContainer.TRUNKS_PY_1) {
                this.y = -200;
            }
        }
    }
}
